import * as React from 'react';
import classNames from 'classnames';
import isMobile from 'rc-util/lib/isMobile';
/**
 * When click and hold on a button - the speed of auto changing the value.
 */
const STEP_INTERVAL = 200;
/**
 * When click and hold on a button - the delay before auto changing the value.
 */
const STEP_DELAY = 600;
export default function StepHandler({ prefixCls, upNode, downNode, upDisabled, downDisabled, symmetryMode, onStep }) {
    // ======================== Step ========================
    const stepTimeoutRef = React.useRef();
    const onStepRef = React.useRef();
    onStepRef.current = onStep;
    // We will interval update step when hold mouse down
    const onStepMouseDown = (e, up) => {
        e.preventDefault();
        onStepRef.current(up);
        // Loop step for interval
        function loopStep() {
            onStepRef.current(up);
            stepTimeoutRef.current = setTimeout(loopStep, STEP_INTERVAL);
        }
        // First time press will wait some time to trigger loop step update
        stepTimeoutRef.current = setTimeout(loopStep, STEP_DELAY);
    };
    const onStopStep = () => {
        clearTimeout(stepTimeoutRef.current);
    };
    React.useEffect(() => onStopStep, []);
    // ======================= Render =======================
    if (isMobile()) {
        return null;
    }
    const handlerClassName = `${prefixCls}-handler`;
    const upClassName = classNames(handlerClassName, `${handlerClassName}-up`, {
        [`${handlerClassName}-up-disabled`]: upDisabled
    });
    const downClassName = classNames(handlerClassName, `${handlerClassName}-down`, {
        [`${handlerClassName}-down-disabled`]: downDisabled
    });
    const sharedHandlerProps = {
        unselectable: 'on',
        role: 'button',
        onMouseUp: onStopStep,
        onMouseLeave: onStopStep
    };
    const handlerContent = (<>
            <span {...sharedHandlerProps} onMouseDown={e => {
            onStepMouseDown(e, true);
        }} aria-label="Increase Value" aria-disabled={upDisabled} className={upClassName}>
                {upNode || <span unselectable="on" className={`${prefixCls}-handler-up-inner`}/>}
            </span>
            <span {...sharedHandlerProps} onMouseDown={e => {
            onStepMouseDown(e, false);
        }} aria-label="Decrease Value" aria-disabled={downDisabled} className={downClassName}>
                {downNode || <span unselectable="on" className={`${prefixCls}-handler-down-inner`}/>}
            </span>
        </>);
    if (symmetryMode) {
        return handlerContent;
    }
    return (<div className={`${handlerClassName}-wrap`}>
            {handlerContent}
        </div>);
}
